import { Button, Grid, Paper, styled } from "@mui/material";
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import React from "react";
import { ConnectedProps, connect } from "react-redux";
import { setStateVariable, updateStateVariables } from "../../AppAction";
import "./Wedding.css";
import { DOCUMENT_SETSTATE } from "./WeddingActionType";
import { openPopup } from "../CommonPopup/PopupReducer";

const apiConfig = window as any;

const GridEditTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#82b6e5',
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[2],
        fontSize: 11,
    },
}));

class WeddingPage extends React.Component<Props> {

    async componentDidMount() {
        const { setStateVariable, updateStateVariables } = this.props;
    }


    shouldComponentUpdate() {
        return true;
    }

    handleDrawerToggle = () => {
        console.log("Test");
    }

    showMoreImage = () => {
        const { setStateVariable, updateStateVariables } = this.props;
        const { wedding } = this.props;
        if (parseInt(wedding.intImage) < apiConfig.MARRIAGE_STOP_COUNTER)
            setStateVariable(DOCUMENT_SETSTATE, "intImage", parseInt(wedding.intImage) + 10);
    }

    weddingPage = () => {
        const { wedding , openPopup} = this.props;

        const iceCarvlistOfImg = [];

        for (let index = 1; index < wedding.intImage; index++) {

            const gallObj = {
                "name": "DSC_" + index + ".jpg"
            }
            iceCarvlistOfImg.push(gallObj);
        }


        // const container = window !== undefined ? () => document.body : undefined;
        return (
            <div >
                <fieldset>
                    <legend className="legendClass">Marriage</legend>
                    <Grid container spacing={2} className="carvingGridContainerClass">
                        {
                            iceCarvlistOfImg.map((abc: any, k: any) => {
                                return (
                                    <Grid key={k} xs={12} sm={3} item>
                                        <Paper key={k} className="imgPaperClass">
                                            {/* <img src={abc.name} className='carouselImg'></img> */}

                                            <img src={process.env.PUBLIC_URL +
                                                "/WeddingImages/" + abc.name} className='galleryImgClass' style={{ cursor: "pointer" }}
                                                onClick={() => openPopup(process.env.PUBLIC_URL + "/WeddingImages/" + abc.name)}
                                            />
                                        </Paper>
                                    </Grid>)
                            })}
                    </Grid>
                    <br />
                    <Button size="medium" className="cardButton" onClick={this.showMoreImage}> Show More</Button>
                </fieldset>
            </div>
        );
    }


    render() {
        return (
            <div className="fullWidth">
                <Grid container>
                    <Grid item xs={12} className="galleryHeader" >
                        Wedding Image
                    </Grid>
                </Grid>
                <div>
                    <this.weddingPage />
                </div>
            </div >
        )
    }
}

const mapStateToProps = (state: any) => {
    const app = state.app;
    const wedding = state.wedding;
    return {
        app: app,
        wedding: wedding,
    };
};

const mapDispatchToProps = {
    setStateVariable,
    updateStateVariables,
    openPopup
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux;

export default connector(WeddingPage);